'use client';

import { OfferWidgetComponent } from './OfferWidgetComponent';

export function OfferWidgetComponentC(
  props: React.ComponentProps<typeof OfferWidgetComponent>,
) {
  return <OfferWidgetComponent {...props} />;
}
